import HardBreak from '@tiptap/extension-hard-break';
import Link from '@tiptap/extension-link';
import { Extension } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

const NBSP_IN_HTML = /\u00a0|&nbsp;|&#160;|&#xa0;/gi;

/**
 * Email clients, Word and web pages join words with `&nbsp;` in the HTML they
 * put on the clipboard. ProseMirror keeps those as U+00A0, which saves a
 * paragraph that renders as one unbreakable word.
 */
const NormalisePastedNbsp = Extension.create({
  name: 'normalisePastedNbsp',
  transformPastedHTML: (html) => html.replace(NBSP_IN_HTML, ' '),
});

/**
 * Hard break that serialises as `\` + newline rather than the CommonMark
 * default of two trailing spaces + newline. Both forms parse to the same
 * `<br>`, but content this editor has already stored uses the backslash form,
 * so we keep that for byte-stable round-trips. Legacy `markdown-draft-js`
 * content has no hard breaks at all — see
 * `docs/technologies/rich-text-markdown.md`.
 */
const MarkdownAwareHardBreak = HardBreak.extend({
  renderMarkdown: () => '\\\n',
});

export const baseEditorExtensions = [
  // StarterKit v3 bundles Link and HardBreak. Disable the bundled versions
  // so the explicit `Link.configure(...)` and `MarkdownAwareHardBreak` below
  // remain authoritative.
  StarterKit.configure({ link: false, hardBreak: false }),
  Link.configure({
    openOnClick: 'whenNotEditable',
    autolink: true,
  }),
  MarkdownAwareHardBreak,
  NormalisePastedNbsp,
];
